//
//  FooterWithCorporateLogo.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { Grid } from "@mui/material";
import { FC } from "react";
import { PUBLIC_URL } from "../utils/env";

interface FooterProps {}

export const FooterWithCorporateLogo: FC<FooterProps> = (props) => {
  return (
    <Grid container>
      <Grid size={9} />
      <Grid size={3} display={"flex"} justifyContent={"center"}>
        <img
          className="logo-image"
          src={`${PUBLIC_URL}/corporate_logo.png`}
          alt="logo"
          style={{ height: "40px", marginTop: 10 }}
        />
      </Grid>
    </Grid>
  );
};
